import React, { useState } from 'react';
import './CardSite.css';


export default function CardSite({ iotdata, sitedata, onSelected }) {
    const [tabs_selected, setTabs_selected] = useState('sensor');

    const getOnlineUI = (state) => {
        if (state) {
            return <div className="pilotlamp-text communication systemnormal mt-0">
                ONLINE
            </div>
        }
        return <div className="pilotlamp-text communication alarming">
            OFFLINE
        </div>
    }
    
    const ReadDatatags_Production = (tagobject, tagname, digit, ispercent) => {
        const value = tagobject?.SiteData?.[tagname];
        if (value === undefined || value === null) {
            return "-";
        }

        if (ispercent !== undefined) {
            if (ispercent === true) {
                if (value >= 100) {
                    return "100"
                }
            }
            return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    const ReadDatatags_Sensor = (enable, tagobject, tagname, digit, unit, sensor_name, con_tag, alert_tag) => {
        const value = tagobject?.SiteData?.environment?.[tagname];
        if (value === undefined || value === null) {
            return <div className="measure-rows">
                <div className="measure-cell border-bottom px-2">{sensor_name}</div>
                <div className="measure-cell border-bottom numberright font-sarabun">-</div>
                <div className="measure-cell border-bottom measunits">{unit}</div>
            </div>;
        }


        var txt_color = ''
        var absnormal = null
        if (tagobject.SiteData.environment.connection_logger === true && tagobject.SiteData.environment.connection_device === true) {
            if (tagobject.SiteData.environment[con_tag]["connection_logger"] === true && tagobject.SiteData.environment[con_tag]["connection_device"] === true) {
                if (tagobject.SiteData.environment[alert_tag] === true) {
                    txt_color = " alarmevent-text-red"
                    absnormal = <span className='health-badge alarming'>ABNORMAL</span>
                } else {
                    txt_color = ""
                }
            } else {
                txt_color = " alarmevent-text-red"
            }
        } else {
            txt_color = " alarmevent-text-red"
        }

        if (enable !== "-") {
            if (tagobject.SiteData.environment[enable] === true) {
                return <div className="measure-rows">
                    <div className="measure-cell border-bottom px-2">{sensor_name} <span className={'health-badge alarming ' + ((tagobject.SiteData.environment[con_tag]["connection_logger"] === false || tagobject.SiteData.environment[con_tag]["connection_device"] === false) && tagobject.SiteData.environment.sequence_type === 1 ? "" : "d-none")} >{tagobject.SiteData.environment[con_tag]["connection_logger"] === false ? "L-" : "D-"}OFFLINE</span> {absnormal}</div>
                    <div className={"measure-cell border-bottom numberright font-sarabun" + txt_color}>{value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
                    <div className="measure-cell border-bottom measunits">{unit}</div>
                </div>
            }
            return null
        }
        return <div className="measure-rows">
            <div className="measure-cell border-bottom px-2">{sensor_name} <span className={'health-badge alarming ' + ((tagobject.SiteData.environment[con_tag]["connection_logger"] === false || tagobject.SiteData.environment[con_tag]["connection_device"] === false) && tagobject.SiteData.environment.sequence_type === 1 ? "" : "d-none")} >{tagobject.SiteData.environment[con_tag]["connection_logger"] === false ? "L-" : "D-"}OFFLINE</span> {absnormal}</div>
            <div className={"measure-cell border-bottom numberright font-sarabun" + txt_color}>{tagobject.SiteData.environment[tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
            <div className="measure-cell border-bottom measunits">{unit}</div>
        </div>
    }

    const ReadDatatags_SensorAVG = (tagobject, tagname, digit, unit, sensor_name) => {
        const value = tagobject?.SiteData?.environment?.[tagname];
        if (value === undefined || value === null) {
            return <div className="measure-rows">
                <div className="measure-cell border-bottom px-2">{sensor_name}</div>
                <div className="measure-cell border-bottom numberright font-sarabun">-</div>
                <div className="measure-cell border-bottom measunits">{unit}</div>
            </div>
        }

        return <div className="measure-rows">
            <div className="measure-cell border-bottom px-2">{sensor_name}</div>
            <div className="measure-cell border-bottom numberright font-sarabun" >{tagobject.SiteData.environment[tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
            <div className="measure-cell border-bottom measunits">{unit}</div>
        </div>
    }

    const getIRRErrorStatus = (data) => {
        const value = data?.error_irr;
        if (value === undefined || value === null) {
            return null
        }

        if (data.error_irr === false) {
            return null
        }
        return <span className='health-badge alarming'>ERROR</span>
    }

    const getPRErrorStatus = (data) => {
        const value = data?.error_pr;
        if (value === undefined || value === null) {
            return null
        }

        if (data.error_pr === false) {
            return null
        }
        return <span className='health-badge alarming'>ERROR</span>
    }

    const getENSErrorStatus = (data) => {
        const value = data?.error_ens;
        if (value === undefined || value === null) {
            return null
        }

        if (data.error_ens === false) {
            return null
        }
        return <span className='health-badge alarming'>ERROR</span>
    }

    const getSolarErrorStatus = (data) => {
        const value = data?.error_solar;
        if (value === undefined || value === null) {
            return null
        }

        if (data.error_ens === false) {
            return null
        }
        return <span className='health-badge alarming'>ERROR</span>
    }

    const getMeter_CT_Alert = (data) => {
        const value = data?.connection_device;
        if (value === undefined || value === null) {
            return null
        }

        if (data.connection_device === true && data.ct_ok === false) {
            return <span className='ms-1 health-badge alarming'>CT</span>
        }
        return null
    }

    const getMeter_Serial_Alert = (data) => {
        const value = data?.connection_device;
        if (value === undefined || value === null) {
            return null
        }

        if (data.connection_device === true && data.serial_ok === false) {
            return <span className='ms-1 health-badge alarming'>SN</span>
        }
        return null
    }

    const getINV_Serial_Alert = (data) => {
        const value = data?.connection_device;
        if (value === undefined || value === null) {
            return null
        }

        if (data.connection_device === true && data.connection_logger === true && data.serial_ok === false) {
            return <span className='ms-1 health-badge alarming'>SN</span>
        }
        return null
    }

    const getIOTStatus = (data) => {
        const value = data?.IOT_Status;
        if (value === undefined || value === null) {
            return <><span className='inverter-alarm-lamp'></span > IOT Backup : Unknown {data.LastUpdateTime}</>
        }

        if (data.IOT_Status === 'Stop') {
            return <><span className='inverter-alarm-lamp alarmevent-blink-bg-orange'></span > IOT Backup : Stopped {data.LastUpdateTime}</>
        } else if (data.IOT_Status === 'Run') {
            return <><span className='inverter-alarm-lamp alarmevent-bg-green'></span > IOT Backup : Running {data.LastUpdateTime}</>
        } else if (data.IOT_Status === 'Error') {
            return <><span className='inverter-alarm-lamp alarmevent-blink-bg-red'></span > IOT Backup : Error {data.LastUpdateTime}</>
        } else if (data.IOT_Status === 'OFFLINE') {
            return <><span className='inverter-alarm-lamp alarmevent-blink-bg-red'></span > IOT Backup : Offline {data.LastUpdateTime}</>
        } else {
            return <><span className='inverter-alarm-lamp'></span > IOT Backup : Unknown {data.LastUpdateTime}</>
        }
    }

    const getIOTVersion = (data) => {
        const value = data?.IOT_Version;
        if (value === undefined || value === null) {
            return ""
        }
        return data.IOT_Version
    }

    return (
        <div>
            <div className="card card-site ">
                <div className="card-body pb-0">
                    <div className="d-flex justify-content-between mb-0 pb-0">
                        <div className="d-block">
                            <h5 className="card-title font-weight-bold mb-0 font-sarabun">{sitedata.SiteCode}, Capacity {sitedata.capacity} kWp</h5>
                            <h6 className="card-text font-weight-bold mt-1 mb-0 font-sarabun">{sitedata.sitename_th}</h6>
                            <p className="card-text mt-0 mb-0 font-sarabun">{sitedata.siteaddress_sm}</p>
                            <h6 className="card-text font-weight-bold mt-1 mb-0 text-blue">{sitedata.solar_type}<span className='text-dark'>, Area {sitedata.factor_area?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m<sup>2</sup></span></h6>
                            <p className="card-text mt-0 mb-2 font-sarabun">{getIOTStatus(iotdata)}</p>
                        </div>
                    </div>
                    <hr className="mt-0 mb-1" />
                </div>

                <div className="card-body pb-2 pt-1">
                    <div className="d-flex justify-content-center gap-2 mb-2 mt-0">
                        {getOnlineUI(sitedata.IsOnline)}
                        {
                            sitedata.SiteData?.commonstatus?.alarmcount_alarm > 0 ?
                                <div className="pilotlamp-text communication alarming">ALARM</div>
                                :
                                sitedata.SiteData?.commonstatus?.alarmcount_warning > 0 ?
                                    <div className="pilotlamp-text communication alarming">WARNING</div>
                                    :
                                    null
                        }
                        {
                            sitedata.SiteData?.status_indicator?.power_limit === true ?
                                <div className="pilotlamp-text communication alarmevent-blink-bg-orange">P LIMIT</div>
                                :
                                null
                        }
                        {
                            sitedata.SiteData?.status_indicator?.common_trip === true ?
                                <div className="pilotlamp-text communication alarming">TRIP</div>
                                :
                                null
                        }
                        {
                            sitedata.SiteData?.status_indicator?.common_shd === true ?
                                <div className="pilotlamp-text communication alarming">SHD</div>
                                :
                                null
                        }
                        {
                            sitedata.SiteData?.status_indicator?.iot_restore_db_count > 0 ?
                                <div className="pilotlamp-text communication alarmevent-blink-bg-yellow">Restore</div>
                                :
                                null
                        }
                    </div>
                    <div className="tabdisplay">
                        <ul className="nav nav-callout" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link " + (tabs_selected === "sensor" ? "active" : "")} type="button" onClick={() => { setTabs_selected("sensor") }}>Production & Sensor</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link " + (tabs_selected === "metering" ? "active" : "")} type="button" onClick={() => { setTabs_selected("metering") }}>Meter</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link " + (tabs_selected === "inverter" ? "active" : "")} type="button" onClick={() => { setTabs_selected("inverter") }}>Inverter</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link " + (tabs_selected === "status" ? "active" : "")} type="button" onClick={() => { setTabs_selected("status") }}>Status</button>
                            </li>
                        </ul>
                    </div>

                    <div style={{ minHeight: "530px" }}>
                        <div className={"measure-table pt-2 font-sarabun " + (tabs_selected !== "sensor" ? "d-none" : "")}>
                            <div className="measure-rows font-bold measure-header-break">
                                <div className="measure-cell px-2">Production</div>
                                <div className="measure-cell"></div>
                                <div className="measure-cell"></div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">IRR.Today {getIRRErrorStatus(sitedata.SiteData)}</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'irr_today', 2, false)}</div>
                                <div className="measure-cell measunits border-bottom">Wh/m<sup>2</sup></div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">% OR {getPRErrorStatus(sitedata.SiteData)}</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'operation_ratio', 2, true)}</div>
                                <div className="measure-cell measunits border-bottom">%</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">% PR {getPRErrorStatus(sitedata.SiteData)}</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'performance_ratio', 2, true)}</div>
                                <div className="measure-cell measunits border-bottom">%</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">% PR 30 Days</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'pr30d', 2, true)}</div>
                                <div className="measure-cell measunits border-bottom">%</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">E.Today {getSolarErrorStatus(sitedata.SiteData)}</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'production_today', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">kWh</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">E.This Month</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'production_thismonth', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">MWh</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">E.This Year</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'production_thisyear', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">MWh</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">E.Total</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'production_total', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">MWh</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">ENS.Today {getENSErrorStatus(sitedata.SiteData)}</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'ens_today', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">kWh</div>
                            </div>
                            <div className="measure-rows font-bold">
                                <div className="measure-cell border-bottom px-2">DC.Today</div>
                                <div className="measure-cell numberright border-bottom">{ReadDatatags_Production(sitedata, 'dc_today', 3, false)}</div>
                                <div className="measure-cell measunits border-bottom">kWh</div>
                            </div>
                            <div className="measure-rows font-bold measure-header-break">
                                <div className="measure-cell px-2">Sensor</div>
                                <div className="measure-cell"></div>
                                <div className="measure-cell">
                                    <span className={'health-badge alarming ' + ((sitedata.SiteData?.environment?.connection_logger === false || sitedata.SiteData?.environment?.connection_device === false) && sitedata.SiteData?.environment?.sequence_type === 0 ? "" : "d-none")} >{sitedata.SiteData?.environment?.connection_logger === false ? "L-" : "D-"}OFFLINE</span>
                                </div>
                            </div>
                            {ReadDatatags_Sensor('-', sitedata, 'total_irr1', 2, <>W/m<sup>2</sup></>, 'Irradiation #1', "connection_irr1", 'sensor_alert_irr1')}
                            {ReadDatatags_Sensor('has_irr2', sitedata, 'total_irr2', 2, <>W/m<sup>2</sup></>, 'Irradiation #2', "connection_irr2", 'sensor_alert_irr2')}
                            {ReadDatatags_SensorAVG(sitedata, 'irr_avg_total', 2, <>W/m<sup>2</sup></>, 'Irradiation AVG.')}
                            {ReadDatatags_Sensor('-', sitedata, 'ambient_temp', 2, '°C', 'Ambient Temp.', "connection_ambient_rh", 'sensor_alert_temp_ambient')}
                            {ReadDatatags_Sensor('-', sitedata, 'pv_temp', 2, '°C', 'Panel Temp.', "connection_temp_pv", 'sensor_alert_temp_pv')}
                            {ReadDatatags_Sensor('-', sitedata, 'custom1_tempraceway', 2, '°C', 'Tray Temp.', "connection_temp_tray", 'sensor_alert_temp_tray')}
                            {ReadDatatags_Sensor('-', sitedata, 'custom2_rh', 2, '%RH', 'Relative Humidity', "connection_ambient_rh", 'sensor_alert_humidity')}
                            {ReadDatatags_Sensor('has_windspeed', sitedata, 'windspeed', 2, 'm/sec.', 'Wind Speed', "connection_windsensor", 'sensor_alert_wind_speed')}
                            {ReadDatatags_Sensor('has_windspeed', sitedata, 'winddirection', 0, '°', 'Wind Direction', "connection_windsensor", 'sensor_alert_wind_direction')}
                            {ReadDatatags_Sensor('has_waterlevel', sitedata, 'waterlevel', 2, 'm.', 'Water Level', "connection_waterlevel", 'sensor_alert_water_level')}
                        </div>

                        <div className={"measure-table pt-2 font-sarabun " + (tabs_selected !== "metering" ? "d-none" : "")}>
                            {
                                sitedata.SiteData?.quickmeter?.length > -1 ?
                                    sitedata.SiteData?.quickmeter?.map((meter, index) => (
                                        <React.Fragment key={meter.meter_name}>
                                            <div className="measure-rows font-bold measure-header-break">
                                                <div className="measure-cell px-2">{meter.meter_name} {index > 0 ? getMeter_Serial_Alert(meter) : null}</div>
                                                <div className="measure-cell"></div>
                                                <div className="measure-cell measunits"><span className={'health-badge alarming ' + ((meter.connection_logger === false || meter.connection_device === false) ? "" : "d-none")} >{meter.connection_logger === false ? "L-" : "D-"}OFFLINE</span></div>
                                            </div>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2">Voltage</div>
                                                <div className="measure-cell numberright border-bottom">{meter.voltage?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">V</div>
                                            </div>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2">Current</div>
                                                <div className="measure-cell numberright border-bottom">{meter.current?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">A</div>
                                            </div>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2">Power Active</div>
                                                <div className="measure-cell numberright border-bottom">{meter.power_active?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">kW</div>
                                            </div>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2">Energy Total Import</div>
                                                <div className="measure-cell numberright border-bottom">{meter.energy_import?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">kWh</div>
                                            </div>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2">Energy Total Export</div>
                                                <div className="measure-cell numberright border-bottom">{meter.energy_export?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">kWh</div>
                                            </div>
                                            {
                                                index > 0 ?
                                                    <div className="measure-rows font-bold">
                                                        <div className="measure-cell border-bottom px-2">CT Ratio, Pri/Sec {getMeter_CT_Alert(meter)}</div>
                                                        <div className="measure-cell numberright border-bottom">{meter.ct_ratio}</div>
                                                        <div className="measure-cell measunits border-bottom"></div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </React.Fragment>
                                    ))
                                    :
                                    null
                            }
                        </div>

                        <div className={"measure-table pt-2 font-sarabun " + (tabs_selected !== "inverter" ? "d-none" : "")}>
                            <div className="measure-rows font-bold measure-header-break">
                                <div className="measure-cell px-2">Inverter No.</div>
                                <div className="measure-cell numberright">P.Active</div>
                                <div className="measure-cell"></div>
                                <div className="measure-cell numberright">E.Today</div>
                                <div className="measure-cell"></div>
                            </div>
                            {
                                sitedata.SiteData?.quickinverter?.length > -1 ?
                                    sitedata.SiteData?.quickinverter?.map((inverter, index) => (
                                        <React.Fragment key={inverter.inverter_name}>
                                            <div className="measure-rows font-bold">
                                                <div className="measure-cell border-bottom px-2 py-0">
                                                    <div className='d-block my-0 py-0'>
                                                        <div className='d-flex mb-0 py-0'>
                                                            <h6 className='inverter-serial-tag'>
                                                                {inverter.inverter_name} {getINV_Serial_Alert(inverter)}
                                                            </h6>
                                                            <span className={'ms-1 health-badge alarming ' + ((inverter.connection_logger === false || inverter.connection_device === false) ? "mb-0" : "d-none")} >{inverter.connection_logger === false ? "L-" : "D-"}OFFLINE</span>
                                                            <span className={'ms-1 health-badge alarming ' + ((inverter.connection_logger === true && inverter.connection_device === true && inverter.fault_code > 0) ? "mb-0" : "d-none")} >F {inverter.fault_code}</span>
                                                            <span className={'ms-1 health-badge alarming ' + ((inverter.connection_logger === true && inverter.connection_device === true && !inverter.is_run_shutdown) ? "mb-0" : "d-none")} >SHD</span>
                                                        </div>
                                                        <h6 className='inverter-serial-bottom'>
                                                            SN: {inverter.serial_no}
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div className="measure-cell numberright font-sarabun border-bottom">{inverter.power_active?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">kW</div>
                                                <div className="measure-cell numberright font-sarabun border-bottom">{inverter.energy_today?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                <div className="measure-cell measunits border-bottom">kWh</div>
                                            </div>
                                        </React.Fragment>
                                    ))
                                    :
                                    null
                            }
                        </div>

                        <div className={"font-poppins pt-2 " + (tabs_selected !== "status" ? "d-none" : "")}>
                            <p className='font-bold fw-600 mt-0 mb-0'>Environment Sensor Status</p>
                            <div className='d-flex flex-wrap mt-2 gap-2'>
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_irr1 === true ? "alarming" : "")}>
                                        IRR #1
                                    </div>
                                }
                                {
                                    sitedata.SiteData?.status_indicator?.has_irr2 === true ?
                                        <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_irr2 === true ? "alarming" : "")}>
                                            IRR #2
                                        </div>
                                        :
                                        null
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_temp_ambient === true ? "alarming" : "")}>
                                        Temp. Ambient
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_humidity === true ? "alarming" : "")}>
                                        R.Humidity
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_temp_pv === true ? "alarming" : "")}>
                                        Temp. PV
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_temp_tray === true ? "alarming" : "")}>
                                        Temp. Tray
                                    </div>
                                }
                                {
                                    sitedata.SiteData?.status_indicator?.has_windspeed === true ?
                                        <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_wind_speed === true ? "alarming" : "")}>
                                            Wind Speed
                                        </div>
                                        :
                                        null
                                }
                                {
                                    sitedata.SiteData?.status_indicator?.has_windspeed === true ?
                                        <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_wind_direction === true ? "alarming" : "")}>
                                            Wind Direction
                                        </div>
                                        :
                                        null
                                }
                                {
                                    sitedata.SiteData?.status_indicator?.has_waterlevel === true ?
                                        <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.sensor_alert_water_level === true ? "alarming" : "")}>
                                            Water Level
                                        </div>
                                        :
                                        null
                                }
                            </div>

                            <p className='font-bold fw-600 mt-2 mb-0'>Protection #1 Status</p>
                            <div className='d-flex flex-wrap mt-2 gap-2'>
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB1_Status_On === false ? "alarming" : "")}>
                                        MCCB
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB1_Emergency_Switch === true ? "alarming" : "")}>
                                        EMER
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB1_Trip_Main_CMD === true ? "alarming" : "")}>
                                        AC SHD
                                    </div>
                                }
                                {
                                    sitedata.solar_type !== "Farm" ?
                                        <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB1_Trip_Rapid_CMD === true ? "alarming" : "")}>
                                            DC SHD
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            {
                                sitedata.SiteData?.status_indicator?.Has_MCB2 === true ?
                                    <>
                                        <p className='font-bold fw-600 mt-2 mb-0'>Protection #2 Status</p>
                                        <div className='d-flex flex-wrap mt-2 gap-2'>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB2_Status_On === false ? "alarming" : "")}>
                                                MCCB
                                            </div>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB2_Emergency_Switch === true ? "alarming" : "")}>
                                                EMER
                                            </div>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB2_Trip_Main_CMD === true ? "alarming" : "")}>
                                                AC SHD
                                            </div>
                                            {
                                                sitedata.solar_type !== "Farm" ?
                                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB2_Trip_Rapid_CMD === true ? "alarming" : "")}>
                                                        DC SHD
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </>
                                    :
                                    null
                            }
                            {
                                sitedata.SiteData?.status_indicator?.Has_MCB3 === true ?
                                    <>
                                        <p className='font-bold fw-600 mt-2 mb-0'>Protection #3 Status</p>
                                        <div className='d-flex flex-wrap mt-2 gap-2'>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB3_Status_On === false ? "alarming" : "")}>
                                                MCCB
                                            </div>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.MCB3_Emergency_Switch === true ? "alarming" : "")}>
                                                EMER
                                            </div>
                                            <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB3_Trip_Main_CMD === true ? "alarming" : "")}>
                                                AC SHD
                                            </div>
                                            {
                                                sitedata.solar_type !== "Farm" ?
                                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.FB_Remote_MCB3_Trip_Rapid_CMD === true ? "alarming" : "")}>
                                                        DC SHD
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </>
                                    :
                                    null
                            }
                            <p className='font-bold fw-600 mt-2 mb-0'>PLC & Huawei Logger Status</p>
                            <div className='d-flex flex-wrap mt-2 gap-2'>
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.plc_alarm === false ? "alarming" : "")}>
                                        PLC Controller
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.logger_alarm === false ? "alarming" : "")}>
                                        Huawei Logger
                                    </div>
                                }
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.commonstatus?.iot_device === false ? "alarming" : "")}>
                                        IOT
                                    </div>
                                }
                            </div>
                            <p className='font-bold fw-600 mt-2 mb-0'>Metering Status</p>
                            <div className='d-flex flex-wrap mt-2 gap-2'>
                                {
                                    <div className={'site-health-indicator ' + (sitedata.SiteData?.status_indicator?.meter_grid_alarm === false ? "alarming" : "")}>
                                        Grid Meter
                                    </div>
                                }
                                {
                                    sitedata.SiteData?.status_indicator?.meter_solar_alarm?.map((status, index) => (
                                        <div className={'site-health-indicator ' + (status.value === false ? "alarming" : "")} key={status.alarm_name + + "-solar"}>
                                            {status.alarm_name}
                                        </div>
                                    ))
                                }
                            </div>
                            <p className='font-bold fw-600 mt-2 mb-0'>Inverter Status</p>
                            <div className='d-flex flex-wrap mt-2 gap-2'>
                                {
                                    sitedata.SiteData?.status_indicator?.inverter_alarm?.map((status, index) => (
                                        <div className={'site-health-indicator ' + (status.value === false ? "alarming" : "")} key={status.alarm_name + "-INV"}>
                                            {status.alarm_name}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    <button className='btn btn-sm btn-secondary mb-1'
                        onClick={() => {
                            onSelected(sitedata.SiteCode,
                                sitedata.sitename_en,
                                sitedata.sitename_th,
                                "/proxy/local/" + sitedata.SiteCode)
                        }}
                    >Site Access</button>

                    <p className="mt-0 mb-0 text-update text-dark"><i className="mdi mdi-clock-check-outline pe-1"></i>Last Data Updated : {sitedata.LastUpdateTime}</p>
                    <p className="mt-0 mb-0 text-update text-dark">Local API Version : {sitedata.SiteData?.api_version}, IOT Version : {getIOTVersion(iotdata)}</p>
                </div>
            </div>


        </div>
    )
}
